export default {
  title: 'Personal Information',
  buttons: {
    save: 'Save',
  },
  toasts: {
    personal_info_updated_successfully: 'Successfully saved your information',
  },
};
